import api from '../../common/api';

export const apiSendContact = (values) => api.pikApi.fetch('POST', '/v1/mail/send', values);

export const apiPhoneCheck = (data, hash) => api.pikApi.fetch('POST', '/v1/phone/check', data, { headers: { 'Send-ID': hash } });
